export default __webpack_public_path__ + "static/media/twende.45f26987.jpg";